import { render, staticRenderFns } from "./MyPlaylistItem.vue?vue&type=template&id=5483eb62&scoped=true&"
import script from "./MyPlaylistItem.vue?vue&type=script&lang=js&"
export * from "./MyPlaylistItem.vue?vue&type=script&lang=js&"
import style0 from "./MyPlaylistItem.vue?vue&type=style&index=0&id=5483eb62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5483eb62",
  null
  
)

export default component.exports